import { t } from '@lingui/core/macro';
import { Alert } from '@pocketlaw/tetris';
export function LoadErrorAlert() {
    return (<Alert appearance="danger" message={t({
            message: 'Could not load signing parties, please try again',
            comment: 'Error message for loading template default signatories',
        })}/>);
}
